import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LanguageSwitcher from "../components/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import "./Auth.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const user = await login(email, password);
      if (user.role === "CLIENT") navigate("/client");
      else if (user.role === "ANALYST") navigate("/analyst");
      else if (user.role === "ADMIN") navigate("/admin");
    } catch (err) {
      setError(err.message || t("auth.loginFailed"));
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <Link to="/" className="auth-logo">
            <div className="logo-icon">DSTL</div>
          </Link>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 12,
              width: "100%",
            }}
          >
            <div>
              <h1>{t("auth.signIn")}</h1>
              <p>{t("auth.accessDashboard")}</p>
            </div>
            <LanguageSwitcher />
          </div>
        </div>

        <div className="auth-note">
          {t("auth.useOrgCredentials")}
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t("auth.email")}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t("auth.emailPlaceholder")}
              required
            />
          </div>

          <div className="form-group">
            <label>{t("auth.password")}</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t("auth.passwordPlaceholder")}
              required
            />
          </div>

          {error && <div className="form-error">{error}</div>}

          <button type="submit" className="btn btn-primary btn-block">
            {t("auth.signIn")}
          </button>
        </form>

        <div className="auth-footer">
          <p>{t("auth.noAccount")}</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
